export const companies = [
  {
    name: "UC Davis",
    type: "Education and Computer Science",
    work: [
      "Currently pursuing my Master's in Electrical and Computer Engineering at the University of California, Davis",
      "Working as a Graduate Teaching Assistant for Prof. Sophia Mattingly, course EDU 122",
      "Working with Prof. Mohammad Sadoghi at the Exploratory Systems Lab on the sustainable blockchain fabric - ResilientDb"
    ],
    position: "Graduate Student",
    duration: "Sep '23 - Present",
  },
  {
    name: "Prosperix",
    type: "Software",
    work: [
      "My work will be updated shortly! Till then here is what Prosperix does:-",
      "Prosperix is a workforce innovation company that develops software solutions that enable businesses to build an extraordinary workforce. To help businesses realize their highest potential and deliver meaningful impact, we have pioneered a new way of building and managing a thriving workforce. Our ultimate aim is for our solutions to positively impact human, workforce, and business prosperity.",
    ],
    position: "Software Engineer",
    duration: "Mar '23 - Aug '23",
  },
  {
    name: "Dr SB's",
    type: "Software",
    work: [
      "Designed and worked on the company website using React and Node.js. Developed the dB schema using PostgreSQL",
      "Implemented authentication and authorization using Google OAuth",
      "Digitized lab report generation from MS Word to Web. Reduced lab report generation time significantly",
      "Developed direct web to WhatsApp report sharing by developing npm packages",
      "Implemented RESTful APIs in Node.js for analytics measurement and created customer check-in and reminder functionalities",
    ],
    position: "Software Development Engineer",
    duration: "Jan '22 - Feb '23",
  },
  {
    name: "2WheelR",
    type: "Analytics and Web",
    work: [
      "Developed and set up business process to collect and collate data which was later analyzed to generate actionable insights resulting in increased revenue and margin",
      "Designed a dashboard by selecting relevant KPIs which was implemented as a part of the digital transformation effort",
    ],
    position: "CEO's Strategy & Operations Team",
    duration: "Jan '21 - Dec '21",
  },
  {
    name: "Teach for India",
    type: "NGO",
    work: [
      "Taught and mentored 60 students coming from under-privileged communities in Math, History and Science at a local school",
      "Conducted personality development workshops, field visits and gatherings to increase engagement, merit and holistic development",
    ],
    position: "Fellow",
    duration: "May '20 - Jun '21",
  },
  {
    name: "Forbes Marshall",
    type: "Internship",
    work: [
      "Designed the control circuit of the Swiss New Water's novel disinfectant dispenser according to IPC specifications and implemented it using schematics developed in Eagle",
      "Developed schematics for a prototype based on Texas Instruments' XTR 111 precision voltage-to-current converter",
      "Oversaw purchase and procurement of materials required for the product",
    ],
    position: "Project Trainee",
    duration: "Jun '19 - Jul '19",
  },
  {
    name: "Open Links Fdn",
    type: "NGO",
    work: [
      "Created and trained a network of volunteers to aide in the increase of the reach of the organization",
      "Facilitated inclusive communication between all stakeholders for efficient workflow and optimum utilization of resources",
      "Conducted multiple workshops to elevate technological literacy and facilitate holistic personality development in various schools for students coming from under-privileged communities.",
    ],
    position: "Volunteer",
    duration: "Nov '18 - May '20",
  },
];
